function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.76 2.82v-.06A1.41 1.41 0 011.92 2a1.64 1.64 0 01.46-.5A1.89 1.89 0 013 1.25a2.64 2.64 0 01.68-.09 2.44 2.44 0 011.13.26 2.21 2.21 0 01.8.67l1-1A3.23 3.23 0 005.38.31 4.27 4.27 0 003.75 0a4.77 4.77 0 00-1.22.16 3.27 3.27 0 00-1.09.51 2.73 2.73 0 00-.79.89 2.54 2.54 0 00-.3 1.27A2.63 2.63 0 00.57 4a3.13 3.13 0 011.19-1.18zM6.42 6.18A3.13 3.13 0 015.19 8a1.49 1.49 0 01-.09.24 1.69 1.69 0 01-.47.53 2 2 0 01-.63.36 2.58 2.58 0 01-.7.1 2.69 2.69 0 01-2.22-1.14L0 9a3.6 3.6 0 001.45 1 4.67 4.67 0 001.81.36 4.55 4.55 0 001.28-.18 3.24 3.24 0 001.1-.55 2.74 2.74 0 00.76-.94 2.92 2.92 0 00.29-1.29 2.52 2.52 0 00-.27-1.22z",
  fill: "#d2d2d2",
  className: "svg-no-adaptive-fill"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 6.69 10.41"
  }, props), _ref);
};

export default SvgComponent;